import React, { useEffect, useCallback } from "react";
import { View, Pressable, StyleSheet, Platform, Linking } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import {
  currentAuthSession,
  supportAccessEnd,
  SupportAccessInfo,
} from "../../OS/Login/State";
import { DateTime } from "luxon";
import { AHText, Box, useTime } from "arkh";
import { waitUntilPersisted } from "@/src/OS/Store";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const BORDER_WIDTH = 2;
const BORDER_COLOR = "#EAB308";

export function SupportAccessBanner() {
  const session = useSelector(currentAuthSession);
  const supportAccess = session?.supportAccess;

  if (!supportAccess) {
    return null;
  }
  return <SupportAccessBannerContent supportAccess={supportAccess} />;
}
function SupportAccessBannerContent(props: {
  supportAccess: SupportAccessInfo;
}) {
  const dispatch = useDispatch();

  const insets = useSafeAreaInsets();

  const expireAt = props.supportAccess.expiresAt
    ? DateTime.fromSeconds(props.supportAccess.expiresAt)
    : null;
  const now = useTime(1000);
  const formattedExpiresIn = expireAt
    ? expireAt.toRelative({ style: "short", base: now })
    : "";

  useEffect(() => {
    if (expireAt && expireAt < now) {
      dispatch(supportAccessEnd());
    }
  }, [expireAt, now, dispatch]);

  const handleEnd = useCallback(async () => {
    dispatch(supportAccessEnd());
    await waitUntilPersisted();
    if (Platform.OS === "web") {
      window.close();
    } else {
      Linking.openURL("https://admin.storesprint.app");
    }
  }, [dispatch]);

  return (
    <View
      style={{
        ...StyleSheet.absoluteFillObject,
        zIndex: 9999,
      }}
      pointerEvents="box-none"
    >
      <View
        style={{
          ...StyleSheet.absoluteFillObject,
          borderWidth: BORDER_WIDTH,
          borderColor: BORDER_COLOR,
        }}
        pointerEvents="none"
      />
      <View
        style={{
          position: "absolute",
          bottom: BORDER_WIDTH + 8 + insets.bottom,
          left: 0,
          right: 0,
          alignItems: "center",
        }}
        pointerEvents="box-none"
      >
        <Box
          color="darkerText"
          cornerRadius="medium"
          gap="medium"
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
          spaceVertical="small"
          spaceHorizontal="medium"
        >
          <AHText color="text-inverted" type="subtitle">
            {props.supportAccess.adminEmail}
          </AHText>
          <AHText color="washedText" type="subtitle">
            {formattedExpiresIn}
          </AHText>
          <Pressable
            style={{
              backgroundColor: "#DC2626",
              paddingHorizontal: 10,
              paddingVertical: 4,
              borderRadius: 12,
            }}
            onPress={handleEnd}
          >
            <AHText color="text-inverted" type="subtitle">
              End Session
            </AHText>
          </Pressable>
        </Box>
      </View>
    </View>
  );
}
